/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { TiptapEditorToolbarButton } from "./TiptapEditorToolbarButton";
import { FormatBold, FormatListBulleted, FormatListNumbered, FormatUnderlined } from "@mui/icons-material";
import { Stack, SxProps, Theme } from "@mui/material";
import React from "react";
import { useCurrentEditor, useEditorState } from "@tiptap/react";
import { tiptapEditorToolbarStyle } from "./tiptapEditorToolbarStyle";

type TiptapEditorToolbar = {
  sx?: SxProps<Theme>;
};

export const TiptapEditorToolbar = ({ sx }: TiptapEditorToolbar) => {
  const { editor } = useCurrentEditor();

  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => {
      if (!editor) {
        return null;
      }

      return {
        boldActive: editor.isActive("bold"),
        underlineActive: editor.isActive("underline"),
        bulletListActive: editor.isActive("bulletList"),
        orderedListActive: editor.isActive("orderedList"),
      };
    },
  });

  return (
    <Stack
      direction={"row"}
      sx={{
        ...tiptapEditorToolbarStyle.container,
        ...sx,
      }}
    >
      <TiptapEditorToolbarButton onClick={() => editor?.commands.toggleBold()} icon={<FormatBold />} label={"Fett"} isActive={editorState?.boldActive} />
      <TiptapEditorToolbarButton
        onClick={() => editor?.commands.toggleUnderline()}
        icon={<FormatUnderlined />}
        label={"Unterstreichen"}
        isActive={editorState?.underlineActive}
      />
      <TiptapEditorToolbarButton
        onClick={() => editor?.chain().focus().toggleBulletList().run()}
        icon={<FormatListBulleted />}
        label={"Aufzählung"}
        isActive={editorState?.bulletListActive}
      />
      <TiptapEditorToolbarButton
        onClick={() => editor?.chain().focus().toggleOrderedList().run()}
        icon={<FormatListNumbered />}
        label={"Nummerierte Liste"}
        isActive={editorState?.orderedListActive}
      />
    </Stack>
  );
};
